import { Clock, CalendarRange, Truck, MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    icon: Clock,
    title: "Noleggio Breve Termine",
    desc: "Da un giorno a qualche settimana: l'auto giusta per viaggi, weekend e imprevisti, senza vincoli.",
    testid: "service-card-breve-termine",
  },
  {
    icon: CalendarRange,
    title: "Noleggio Lungo Termine",
    desc: "Canone fisso mensile, manutenzione e assistenza incluse. La mobilità aziendale senza pensieri.",
    testid: "service-card-lungo-termine",
  },
  {
    icon: Truck,
    title: "Furgoni & Traslochi",
    desc: "Dal furgone compatto al Ducato da 13 m³: soluzioni cargo per artigiani, aziende e traslochi.",
    testid: "service-card-furgoni",
  },
  {
    icon: MapPin,
    title: "Consegna & Ritiro",
    desc: "Consegniamo il veicolo dove ti serve: aeroporti, stazioni, hotel o direttamente a casa tua.",
    testid: "service-card-consegna",
  },
];

export const Services = () => (
  <section id="servizi" className="py-24 sm:py-32 bg-white" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8">
      <Reveal>
        <p className="text-xs font-mono font-semibold uppercase tracking-[0.25em] text-emerald-700 mb-4">I servizi</p>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 max-w-xl">
            Servizi su misura, per privati e aziende.
          </h2>
          <p className="text-sm text-slate-500 max-w-sm leading-relaxed">
            Ogni richiesta è seguita personalmente dal nostro operatore. Nessun modulo automatico decide al posto tuo.
          </p>
        </div>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08}>
            <div
              className="group h-full rounded-3xl border border-slate-200 bg-[#fafafa] p-8 hover:bg-slate-900 hover:border-slate-900 transition-colors duration-500"
              data-testid={s.testid}
            >
              <div className="flex items-start justify-between">
                <s.icon className="w-8 h-8 text-emerald-600 group-hover:text-emerald-400 transition-colors duration-500" />
                <ArrowUpRight className="w-5 h-5 text-slate-300 group-hover:text-emerald-400 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-500" />
              </div>
              <h3 className="mt-8 font-display text-lg font-bold text-slate-900 group-hover:text-white transition-colors duration-500">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-slate-600 group-hover:text-slate-400 leading-relaxed transition-colors duration-500">
                {s.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
